/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { BaseClientApi, ClientApiConfig } from '@eta/components';
import axios, {
    AxiosInstance,
    CancelToken,
    AxiosRequestConfig,
    AxiosResponse,
    AxiosError,
} from 'axios';

export interface IPosManagementPublicClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    validateDevices(body?: DeviceKeyDto[] | undefined): Promise<ValidateDeviceResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addDevices(body?: CurrentDeviceDto[] | undefined): Promise<CurrentDeviceBulkResponseDto>;
    /**
     * @param vendorId (optional) 
     * @param vendorName (optional) 
     * @param modelId (optional) 
     * @param modelName (optional) 
     * @param name (optional) 
     * @param branchName (optional) 
     * @param address (optional) 
     * @param serialNumber (optional) 
     * @param branchCode (optional) 
     * @param activeFrom (optional) 
     * @param activeTo (optional) 
     * @param status (optional) 
     * @param lastReceiptDate (optional) 
     * @param pn (optional) 
     * @param ps (optional) 
     * @param sortBy (optional) 
     * @param sortDir (optional) 
     * @return Success
     */
    getCurrentDevices(vendorId?: number | undefined, vendorName?: string | undefined, modelId?: number | undefined, modelName?: string | undefined, name?: string | undefined, branchName?: string | undefined, address?: string | undefined, serialNumber?: string | undefined, branchCode?: number | undefined, activeFrom?: Date | undefined, activeTo?: Date | undefined, status?: DeviceStatus | undefined, lastReceiptDate?: Date | undefined, pn?: number | undefined, ps?: number | undefined, sortBy?: CurrentDevicesSortBy | undefined, sortDir?: SortDir | undefined): Promise<CurrentDeviceListItemDtoQueryListResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editCurrentDevice(id: number, body?: EditCurrentDeviceDto | undefined): Promise<number>;
    /**
     * @return Success
     */
    getDeviceDetails(id: number): Promise<TaxpayerDeviceDetailDto>;
    /**
     * @param clientID (optional) 
     * @param posSerial (optional) 
     * @return Success
     */
    getDeviceDetailsByPosSerial(clientID?: string | undefined, posSerial?: string | undefined): Promise<DeivcePosDetailsDto>;
    /**
     * @return Success
     */
    getTaxpayerPOSDetails(): Promise<TaxpayerPosDetailsDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editDevicesStatus(body?: CurrentDeviceStatusCommandDto | undefined): Promise<DeviceBulkResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    regenerateDeviceCredentials(id: number, body?: RegenerateDeviceCredentialsDto | undefined): Promise<RegenerateDeviceCredentialsResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    retireDevices(body?: RetireDevicesRequestDto | undefined): Promise<RetireDevicesResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    revertRetireDevices(body?: RevertRetireDevicesRequestDto | undefined): Promise<RevertRetireDevicesResponseDto>;
    /**
     * @param language (optional) 
     * @return Success
     */
    config(language?: string | undefined): Promise<GetLookupResponseDto>;
    /**
     * @param vendorId (optional) 
     * @param vendorName (optional) 
     * @param name (optional) 
     * @param vendorOrModelName (optional) 
     * @param certificationNumber (optional) 
     * @param type (optional) 
     * @param status (optional) 
     * @param vendorStatus (optional) 
     * @param activeFrom (optional) 
     * @param activeTo (optional) 
     * @param pn (optional) 
     * @param ps (optional) 
     * @param sortBy (optional) 
     * @param sortDir (optional) 
     * @return Success
     */
    getModels(vendorId?: number | undefined, vendorName?: string | undefined, name?: string | undefined, vendorOrModelName?: string | undefined, certificationNumber?: string | undefined, type?: ModelType | undefined, status?: ModelStatus | undefined, vendorStatus?: VendorStatus | undefined, activeFrom?: Date | undefined, activeTo?: Date | undefined, pn?: number | undefined, ps?: number | undefined, sortBy?: ModelSortBy | undefined, sortDir?: SortDir | undefined): Promise<ModelListItemDtoQueryListResult>;
    /**
     * @return Success
     */
    getPosConfig(): Promise<PosConfigDto>;
}

export class PosManagementPublicClient extends BaseClientApi implements IPosManagementPublicClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientApiConfig, baseUrl?: string, instance?: AxiosInstance) {
        super(configuration);
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateDevices(body?: DeviceKeyDto[] | undefined, cancelToken?: CancelToken | undefined): Promise<ValidateDeviceResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/pos/devices/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateDevices(_response);
        });
    }

    protected processValidateDevices(response: AxiosResponse): Promise<ValidateDeviceResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ValidateDeviceResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateDeviceResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addDevices(body?: CurrentDeviceDto[] | undefined, cancelToken?: CancelToken | undefined): Promise<CurrentDeviceBulkResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/pos/devices/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDevices(_response);
        });
    }

    protected processAddDevices(response: AxiosResponse): Promise<CurrentDeviceBulkResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = CurrentDeviceBulkResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentDeviceBulkResponseDto>(<any>null);
    }

    /**
     * @param vendorId (optional) 
     * @param vendorName (optional) 
     * @param modelId (optional) 
     * @param modelName (optional) 
     * @param name (optional) 
     * @param branchName (optional) 
     * @param address (optional) 
     * @param serialNumber (optional) 
     * @param branchCode (optional) 
     * @param activeFrom (optional) 
     * @param activeTo (optional) 
     * @param status (optional) 
     * @param lastReceiptDate (optional) 
     * @param pn (optional) 
     * @param ps (optional) 
     * @param sortBy (optional) 
     * @param sortDir (optional) 
     * @return Success
     */
    getCurrentDevices(vendorId?: number | undefined, vendorName?: string | undefined, modelId?: number | undefined, modelName?: string | undefined, name?: string | undefined, branchName?: string | undefined, address?: string | undefined, serialNumber?: string | undefined, branchCode?: number | undefined, activeFrom?: Date | undefined, activeTo?: Date | undefined, status?: DeviceStatus | undefined, lastReceiptDate?: Date | undefined, pn?: number | undefined, ps?: number | undefined, sortBy?: CurrentDevicesSortBy | undefined, sortDir?: SortDir | undefined, cancelToken?: CancelToken | undefined): Promise<CurrentDeviceListItemDtoQueryListResult> {
        let url_ = this.baseUrl + "/api/v{version}/pos/devices/current?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "VendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (vendorName === null)
            throw new Error("The parameter 'vendorName' cannot be null.");
        else if (vendorName !== undefined)
            url_ += "VendorName=" + encodeURIComponent("" + vendorName) + "&";
        if (modelId === null)
            throw new Error("The parameter 'modelId' cannot be null.");
        else if (modelId !== undefined)
            url_ += "ModelId=" + encodeURIComponent("" + modelId) + "&";
        if (modelName === null)
            throw new Error("The parameter 'modelName' cannot be null.");
        else if (modelName !== undefined)
            url_ += "ModelName=" + encodeURIComponent("" + modelName) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (branchName === null)
            throw new Error("The parameter 'branchName' cannot be null.");
        else if (branchName !== undefined)
            url_ += "BranchName=" + encodeURIComponent("" + branchName) + "&";
        if (address === null)
            throw new Error("The parameter 'address' cannot be null.");
        else if (address !== undefined)
            url_ += "Address=" + encodeURIComponent("" + address) + "&";
        if (serialNumber === null)
            throw new Error("The parameter 'serialNumber' cannot be null.");
        else if (serialNumber !== undefined)
            url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (branchCode === null)
            throw new Error("The parameter 'branchCode' cannot be null.");
        else if (branchCode !== undefined)
            url_ += "BranchCode=" + encodeURIComponent("" + branchCode) + "&";
        if (activeFrom === null)
            throw new Error("The parameter 'activeFrom' cannot be null.");
        else if (activeFrom !== undefined)
            url_ += "ActiveFrom=" + encodeURIComponent(activeFrom ? "" + activeFrom.toJSON() : "") + "&";
        if (activeTo === null)
            throw new Error("The parameter 'activeTo' cannot be null.");
        else if (activeTo !== undefined)
            url_ += "ActiveTo=" + encodeURIComponent(activeTo ? "" + activeTo.toJSON() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (lastReceiptDate === null)
            throw new Error("The parameter 'lastReceiptDate' cannot be null.");
        else if (lastReceiptDate !== undefined)
            url_ += "LastReceiptDate=" + encodeURIComponent(lastReceiptDate ? "" + lastReceiptDate.toJSON() : "") + "&";
        if (pn === null)
            throw new Error("The parameter 'pn' cannot be null.");
        else if (pn !== undefined)
            url_ += "Pn=" + encodeURIComponent("" + pn) + "&";
        if (ps === null)
            throw new Error("The parameter 'ps' cannot be null.");
        else if (ps !== undefined)
            url_ += "Ps=" + encodeURIComponent("" + ps) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDir === null)
            throw new Error("The parameter 'sortDir' cannot be null.");
        else if (sortDir !== undefined)
            url_ += "SortDir=" + encodeURIComponent("" + sortDir) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentDevices(_response);
        });
    }

    protected processGetCurrentDevices(response: AxiosResponse): Promise<CurrentDeviceListItemDtoQueryListResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = CurrentDeviceListItemDtoQueryListResult.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentDeviceListItemDtoQueryListResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editCurrentDevice(id: number, body?: EditCurrentDeviceDto | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/pos/devices/{id}/current";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditCurrentDevice(_response);
        });
    }

    protected processEditCurrentDevice(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @return Success
     */
    getDeviceDetails(id: number, cancelToken?: CancelToken | undefined): Promise<TaxpayerDeviceDetailDto> {
        let url_ = this.baseUrl + "/api/v{version}/pos/devices/{id}/current";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeviceDetails(_response);
        });
    }

    protected processGetDeviceDetails(response: AxiosResponse): Promise<TaxpayerDeviceDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TaxpayerDeviceDetailDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxpayerDeviceDetailDto>(<any>null);
    }

    /**
     * @param clientID (optional) 
     * @param posSerial (optional) 
     * @return Success
     */
    getDeviceDetailsByPosSerial(clientID?: string | undefined, posSerial?: string | undefined, cancelToken?: CancelToken | undefined): Promise<DeivcePosDetailsDto> {
        let url_ = this.baseUrl + "/api/v{version}/pos/devices/current/posserial?";
        if (clientID === null)
            throw new Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        if (posSerial === null)
            throw new Error("The parameter 'posSerial' cannot be null.");
        else if (posSerial !== undefined)
            url_ += "posSerial=" + encodeURIComponent("" + posSerial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeviceDetailsByPosSerial(_response);
        });
    }

    protected processGetDeviceDetailsByPosSerial(response: AxiosResponse): Promise<DeivcePosDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DeivcePosDetailsDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeivcePosDetailsDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTaxpayerPOSDetails(cancelToken?: CancelToken | undefined): Promise<TaxpayerPosDetailsDto> {
        let url_ = this.baseUrl + "/api/v{version}/pos/devices/current/posdetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaxpayerPOSDetails(_response);
        });
    }

    protected processGetTaxpayerPOSDetails(response: AxiosResponse): Promise<TaxpayerPosDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = TaxpayerPosDetailsDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxpayerPosDetailsDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editDevicesStatus(body?: CurrentDeviceStatusCommandDto | undefined, cancelToken?: CancelToken | undefined): Promise<DeviceBulkResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/pos/devices/status/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditDevicesStatus(_response);
        });
    }

    protected processEditDevicesStatus(response: AxiosResponse): Promise<DeviceBulkResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = DeviceBulkResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceBulkResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    regenerateDeviceCredentials(id: number, body?: RegenerateDeviceCredentialsDto | undefined, cancelToken?: CancelToken | undefined): Promise<RegenerateDeviceCredentialsResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/pos/devices/{id}/credentials/current";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegenerateDeviceCredentials(_response);
        });
    }

    protected processRegenerateDeviceCredentials(response: AxiosResponse): Promise<RegenerateDeviceCredentialsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = RegenerateDeviceCredentialsResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegenerateDeviceCredentialsResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    retireDevices(body?: RetireDevicesRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<RetireDevicesResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/pos/devices/current/retire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRetireDevices(_response);
        });
    }

    protected processRetireDevices(response: AxiosResponse): Promise<RetireDevicesResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = RetireDevicesResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RetireDevicesResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    revertRetireDevices(body?: RevertRetireDevicesRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<RevertRetireDevicesResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/pos/devices/current/revert/retire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevertRetireDevices(_response);
        });
    }

    protected processRevertRetireDevices(response: AxiosResponse): Promise<RevertRetireDevicesResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = RevertRetireDevicesResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RevertRetireDevicesResponseDto>(<any>null);
    }

    /**
     * @param language (optional) 
     * @return Success
     */
    config(language?: string | undefined, cancelToken?: CancelToken | undefined): Promise<GetLookupResponseDto> {
        let url_ = this.baseUrl + "/api/v{version}/pos/devices/config?";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfig(_response);
        });
    }

    protected processConfig(response: AxiosResponse): Promise<GetLookupResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = GetLookupResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetLookupResponseDto>(<any>null);
    }

    /**
     * @param vendorId (optional) 
     * @param vendorName (optional) 
     * @param name (optional) 
     * @param vendorOrModelName (optional) 
     * @param certificationNumber (optional) 
     * @param type (optional) 
     * @param status (optional) 
     * @param vendorStatus (optional) 
     * @param activeFrom (optional) 
     * @param activeTo (optional) 
     * @param pn (optional) 
     * @param ps (optional) 
     * @param sortBy (optional) 
     * @param sortDir (optional) 
     * @return Success
     */
    getModels(vendorId?: number | undefined, vendorName?: string | undefined, name?: string | undefined, vendorOrModelName?: string | undefined, certificationNumber?: string | undefined, type?: ModelType | undefined, status?: ModelStatus | undefined, vendorStatus?: VendorStatus | undefined, activeFrom?: Date | undefined, activeTo?: Date | undefined, pn?: number | undefined, ps?: number | undefined, sortBy?: ModelSortBy | undefined, sortDir?: SortDir | undefined, cancelToken?: CancelToken | undefined): Promise<ModelListItemDtoQueryListResult> {
        let url_ = this.baseUrl + "/api/v{version}/pos/models?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "VendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (vendorName === null)
            throw new Error("The parameter 'vendorName' cannot be null.");
        else if (vendorName !== undefined)
            url_ += "VendorName=" + encodeURIComponent("" + vendorName) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (vendorOrModelName === null)
            throw new Error("The parameter 'vendorOrModelName' cannot be null.");
        else if (vendorOrModelName !== undefined)
            url_ += "VendorOrModelName=" + encodeURIComponent("" + vendorOrModelName) + "&";
        if (certificationNumber === null)
            throw new Error("The parameter 'certificationNumber' cannot be null.");
        else if (certificationNumber !== undefined)
            url_ += "CertificationNumber=" + encodeURIComponent("" + certificationNumber) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (vendorStatus === null)
            throw new Error("The parameter 'vendorStatus' cannot be null.");
        else if (vendorStatus !== undefined)
            url_ += "VendorStatus=" + encodeURIComponent("" + vendorStatus) + "&";
        if (activeFrom === null)
            throw new Error("The parameter 'activeFrom' cannot be null.");
        else if (activeFrom !== undefined)
            url_ += "ActiveFrom=" + encodeURIComponent(activeFrom ? "" + activeFrom.toJSON() : "") + "&";
        if (activeTo === null)
            throw new Error("The parameter 'activeTo' cannot be null.");
        else if (activeTo !== undefined)
            url_ += "ActiveTo=" + encodeURIComponent(activeTo ? "" + activeTo.toJSON() : "") + "&";
        if (pn === null)
            throw new Error("The parameter 'pn' cannot be null.");
        else if (pn !== undefined)
            url_ += "Pn=" + encodeURIComponent("" + pn) + "&";
        if (ps === null)
            throw new Error("The parameter 'ps' cannot be null.");
        else if (ps !== undefined)
            url_ += "Ps=" + encodeURIComponent("" + ps) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDir === null)
            throw new Error("The parameter 'sortDir' cannot be null.");
        else if (sortDir !== undefined)
            url_ += "SortDir=" + encodeURIComponent("" + sortDir) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModels(_response);
        });
    }

    protected processGetModels(response: AxiosResponse): Promise<ModelListItemDtoQueryListResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ModelListItemDtoQueryListResult.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelListItemDtoQueryListResult>(<any>null);
    }

    /**
     * @return Success
     */
    getPosConfig(cancelToken?: CancelToken | undefined): Promise<PosConfigDto> {
        let url_ = this.baseUrl + "/api/v{version}/pos/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPosConfig(_response);
        });
    }

    protected processGetPosConfig(response: AxiosResponse): Promise<PosConfigDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = PosConfigDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PosConfigDto>(<any>null);
    }
}

export class AcceptedDeviceDto implements IAcceptedDeviceDto {
    clientSecrets?: ClientSecretModel;
    index?: number;
    deviceId?: number;

    constructor(data?: IAcceptedDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientSecrets = _data["clientSecrets"] ? ClientSecretModel.fromJS(_data["clientSecrets"]) : <any>undefined;
            this.index = _data["index"];
            this.deviceId = _data["deviceId"];
        }
    }

    static fromJS(data: any): AcceptedDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptedDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientSecrets"] = this.clientSecrets ? this.clientSecrets.toJSON() : <any>undefined;
        data["index"] = this.index;
        data["deviceId"] = this.deviceId;
        return data;
    }

    clone(): AcceptedDeviceDto {
        const json = this.toJSON();
        let result = new AcceptedDeviceDto();
        result.init(json);
        return result;
    }
}

export interface IAcceptedDeviceDto {
    clientSecrets?: ClientSecretModel;
    index?: number;
    deviceId?: number;
}

export class ClientSecretModel implements IClientSecretModel {
    clientID?: string | undefined;
    clientSecretOne?: string | undefined;
    clientSecretTow?: string | undefined;
    loginIdOne?: string | undefined;
    loginIdTow?: string | undefined;

    constructor(data?: IClientSecretModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["clientID"];
            this.clientSecretOne = _data["clientSecretOne"];
            this.clientSecretTow = _data["clientSecretTow"];
            this.loginIdOne = _data["loginIdOne"];
            this.loginIdTow = _data["loginIdTow"];
        }
    }

    static fromJS(data: any): ClientSecretModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSecretModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientID"] = this.clientID;
        data["clientSecretOne"] = this.clientSecretOne;
        data["clientSecretTow"] = this.clientSecretTow;
        data["loginIdOne"] = this.loginIdOne;
        data["loginIdTow"] = this.loginIdTow;
        return data;
    }

    clone(): ClientSecretModel {
        const json = this.toJSON();
        let result = new ClientSecretModel();
        result.init(json);
        return result;
    }
}

export interface IClientSecretModel {
    clientID?: string | undefined;
    clientSecretOne?: string | undefined;
    clientSecretTow?: string | undefined;
    loginIdOne?: string | undefined;
    loginIdTow?: string | undefined;
}

export class CurrentDeviceBulkResponseDto implements ICurrentDeviceBulkResponseDto {
    acceptedDevices?: AcceptedDeviceDto[] | undefined;
    rejectedDevices?: CurrentRejectedDeviceDto[] | undefined;

    constructor(data?: ICurrentDeviceBulkResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["acceptedDevices"])) {
                this.acceptedDevices = [] as any;
                for (let item of _data["acceptedDevices"])
                    this.acceptedDevices!.push(AcceptedDeviceDto.fromJS(item));
            }
            if (Array.isArray(_data["rejectedDevices"])) {
                this.rejectedDevices = [] as any;
                for (let item of _data["rejectedDevices"])
                    this.rejectedDevices!.push(CurrentRejectedDeviceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CurrentDeviceBulkResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentDeviceBulkResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.acceptedDevices)) {
            data["acceptedDevices"] = [];
            for (let item of this.acceptedDevices)
                data["acceptedDevices"].push(item.toJSON());
        }
        if (Array.isArray(this.rejectedDevices)) {
            data["rejectedDevices"] = [];
            for (let item of this.rejectedDevices)
                data["rejectedDevices"].push(item.toJSON());
        }
        return data;
    }

    clone(): CurrentDeviceBulkResponseDto {
        const json = this.toJSON();
        let result = new CurrentDeviceBulkResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentDeviceBulkResponseDto {
    acceptedDevices?: AcceptedDeviceDto[] | undefined;
    rejectedDevices?: CurrentRejectedDeviceDto[] | undefined;
}

export class CurrentDeviceCommand implements ICurrentDeviceCommand {
    modelId?: number;
    branchId?: number;
    modelName?: string | undefined;
    vendorName?: string | undefined;
    branchNumber?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    status?: DeviceStatusDto;
    credentialExpiryDate?: Date | undefined;

    constructor(data?: ICurrentDeviceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.branchId = _data["branchId"];
            this.modelName = _data["modelName"];
            this.vendorName = _data["vendorName"];
            this.branchNumber = _data["branchNumber"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.serialNumber = _data["serialNumber"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.credentialExpiryDate = _data["credentialExpiryDate"] ? new Date(_data["credentialExpiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CurrentDeviceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentDeviceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["branchId"] = this.branchId;
        data["modelName"] = this.modelName;
        data["vendorName"] = this.vendorName;
        data["branchNumber"] = this.branchNumber;
        data["name"] = this.name;
        data["description"] = this.description;
        data["serialNumber"] = this.serialNumber;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["credentialExpiryDate"] = this.credentialExpiryDate ? this.credentialExpiryDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CurrentDeviceCommand {
        const json = this.toJSON();
        let result = new CurrentDeviceCommand();
        result.init(json);
        return result;
    }
}

export interface ICurrentDeviceCommand {
    modelId?: number;
    branchId?: number;
    modelName?: string | undefined;
    vendorName?: string | undefined;
    branchNumber?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    status?: DeviceStatusDto;
    credentialExpiryDate?: Date | undefined;
}

export class CurrentDeviceDto implements ICurrentDeviceDto {
    modelName?: string | undefined;
    vendorName?: string | undefined;
    branchNumber?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    status?: DeviceStatusDto;
    credentialExpiryDate?: Date | undefined;

    constructor(data?: ICurrentDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelName = _data["modelName"];
            this.vendorName = _data["vendorName"];
            this.branchNumber = _data["branchNumber"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.serialNumber = _data["serialNumber"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.credentialExpiryDate = _data["credentialExpiryDate"] ? new Date(_data["credentialExpiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CurrentDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName;
        data["vendorName"] = this.vendorName;
        data["branchNumber"] = this.branchNumber;
        data["name"] = this.name;
        data["description"] = this.description;
        data["serialNumber"] = this.serialNumber;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["credentialExpiryDate"] = this.credentialExpiryDate ? this.credentialExpiryDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CurrentDeviceDto {
        const json = this.toJSON();
        let result = new CurrentDeviceDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentDeviceDto {
    modelName?: string | undefined;
    vendorName?: string | undefined;
    branchNumber?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    status?: DeviceStatusDto;
    credentialExpiryDate?: Date | undefined;
}

export class CurrentDeviceListItemDto implements ICurrentDeviceListItemDto {
    id?: number;
    name?: string | undefined;
    status?: DeviceStatus;
    vendorStatus?: VendorStatus;
    modelStatus?: ModelStatus;
    type?: ModelType;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    vendorName?: string | undefined;
    modelName?: string | undefined;
    serialNumber?: string | undefined;
    branchNumber?: number | undefined;
    branchStartDate?: Date;
    branchCeaseDate?: Date | undefined;
    branch?: string | undefined;
    formatedAddress?: string | undefined;
    description?: string | undefined;
    certificationNumber?: string | undefined;
    lastReceiptDate?: Date | undefined;
    vendorOutOfRange?: boolean;
    modelOutOfRange?: boolean;
    firstAuthenticationDate?: Date | undefined;
    lastAuthenticationDate?: Date | undefined;
    isStatusUpdatedByAdmin?: boolean;

    constructor(data?: ICurrentDeviceListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.vendorStatus = _data["vendorStatus"];
            this.modelStatus = _data["modelStatus"];
            this.type = _data["type"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.vendorName = _data["vendorName"];
            this.modelName = _data["modelName"];
            this.serialNumber = _data["serialNumber"];
            this.branchNumber = _data["branchNumber"];
            this.branchStartDate = _data["branchStartDate"] ? new Date(_data["branchStartDate"].toString()) : <any>undefined;
            this.branchCeaseDate = _data["branchCeaseDate"] ? new Date(_data["branchCeaseDate"].toString()) : <any>undefined;
            this.branch = _data["branch"];
            this.formatedAddress = _data["formatedAddress"];
            this.description = _data["description"];
            this.certificationNumber = _data["certificationNumber"];
            this.lastReceiptDate = _data["lastReceiptDate"] ? new Date(_data["lastReceiptDate"].toString()) : <any>undefined;
            this.vendorOutOfRange = _data["vendorOutOfRange"];
            this.modelOutOfRange = _data["modelOutOfRange"];
            this.firstAuthenticationDate = _data["firstAuthenticationDate"] ? new Date(_data["firstAuthenticationDate"].toString()) : <any>undefined;
            this.lastAuthenticationDate = _data["lastAuthenticationDate"] ? new Date(_data["lastAuthenticationDate"].toString()) : <any>undefined;
            this.isStatusUpdatedByAdmin = _data["isStatusUpdatedByAdmin"];
        }
    }

    static fromJS(data: any): CurrentDeviceListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentDeviceListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["vendorStatus"] = this.vendorStatus;
        data["modelStatus"] = this.modelStatus;
        data["type"] = this.type;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["vendorName"] = this.vendorName;
        data["modelName"] = this.modelName;
        data["serialNumber"] = this.serialNumber;
        data["branchNumber"] = this.branchNumber;
        data["branchStartDate"] = this.branchStartDate ? this.branchStartDate.toISOString() : <any>undefined;
        data["branchCeaseDate"] = this.branchCeaseDate ? this.branchCeaseDate.toISOString() : <any>undefined;
        data["branch"] = this.branch;
        data["formatedAddress"] = this.formatedAddress;
        data["description"] = this.description;
        data["certificationNumber"] = this.certificationNumber;
        data["lastReceiptDate"] = this.lastReceiptDate ? this.lastReceiptDate.toISOString() : <any>undefined;
        data["vendorOutOfRange"] = this.vendorOutOfRange;
        data["modelOutOfRange"] = this.modelOutOfRange;
        data["firstAuthenticationDate"] = this.firstAuthenticationDate ? this.firstAuthenticationDate.toISOString() : <any>undefined;
        data["lastAuthenticationDate"] = this.lastAuthenticationDate ? this.lastAuthenticationDate.toISOString() : <any>undefined;
        data["isStatusUpdatedByAdmin"] = this.isStatusUpdatedByAdmin;
        return data;
    }

    clone(): CurrentDeviceListItemDto {
        const json = this.toJSON();
        let result = new CurrentDeviceListItemDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentDeviceListItemDto {
    id?: number;
    name?: string | undefined;
    status?: DeviceStatus;
    vendorStatus?: VendorStatus;
    modelStatus?: ModelStatus;
    type?: ModelType;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    vendorName?: string | undefined;
    modelName?: string | undefined;
    serialNumber?: string | undefined;
    branchNumber?: number | undefined;
    branchStartDate?: Date;
    branchCeaseDate?: Date | undefined;
    branch?: string | undefined;
    formatedAddress?: string | undefined;
    description?: string | undefined;
    certificationNumber?: string | undefined;
    lastReceiptDate?: Date | undefined;
    vendorOutOfRange?: boolean;
    modelOutOfRange?: boolean;
    firstAuthenticationDate?: Date | undefined;
    lastAuthenticationDate?: Date | undefined;
    isStatusUpdatedByAdmin?: boolean;
}

export class CurrentDeviceListItemDtoQueryListResult implements ICurrentDeviceListItemDtoQueryListResult {
    data?: CurrentDeviceListItemDto[] | undefined;
    totalCount?: number;
    pagesCount?: number;

    constructor(data?: ICurrentDeviceListItemDtoQueryListResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CurrentDeviceListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pagesCount = _data["pagesCount"];
        }
    }

    static fromJS(data: any): CurrentDeviceListItemDtoQueryListResult {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentDeviceListItemDtoQueryListResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pagesCount"] = this.pagesCount;
        return data;
    }

    clone(): CurrentDeviceListItemDtoQueryListResult {
        const json = this.toJSON();
        let result = new CurrentDeviceListItemDtoQueryListResult();
        result.init(json);
        return result;
    }
}

export interface ICurrentDeviceListItemDtoQueryListResult {
    data?: CurrentDeviceListItemDto[] | undefined;
    totalCount?: number;
    pagesCount?: number;
}

export enum CurrentDevicesSortBy {
    Default = "Default",
    ActiveFrom = "ActiveFrom",
    ActiveTo = "ActiveTo",
    LastSentReceiptDate = "LastSentReceiptDate",
    Name = "Name",
    SerialNumber = "SerialNumber",
    ModelName = "ModelName",
    VendorName = "VendorName",
    TaxpayerBranchCode = "TaxpayerBranchCode",
    Status = "Status",
}

export class CurrentDeviceStatusCommandDto implements ICurrentDeviceStatusCommandDto {
    devicesId?: number[] | undefined;
    status?: DeviceStatusDto;

    constructor(data?: ICurrentDeviceStatusCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["devicesId"])) {
                this.devicesId = [] as any;
                for (let item of _data["devicesId"])
                    this.devicesId!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CurrentDeviceStatusCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentDeviceStatusCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.devicesId)) {
            data["devicesId"] = [];
            for (let item of this.devicesId)
                data["devicesId"].push(item);
        }
        data["status"] = this.status;
        return data;
    }

    clone(): CurrentDeviceStatusCommandDto {
        const json = this.toJSON();
        let result = new CurrentDeviceStatusCommandDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentDeviceStatusCommandDto {
    devicesId?: number[] | undefined;
    status?: DeviceStatusDto;
}

export class CurrentRejectedDeviceDto implements ICurrentRejectedDeviceDto {
    index?: number;
    device?: CurrentDeviceCommand;
    errors?: ValidationError[] | undefined;

    constructor(data?: ICurrentRejectedDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.device = _data["device"] ? CurrentDeviceCommand.fromJS(_data["device"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ValidationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CurrentRejectedDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentRejectedDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }

    clone(): CurrentRejectedDeviceDto {
        const json = this.toJSON();
        let result = new CurrentRejectedDeviceDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentRejectedDeviceDto {
    index?: number;
    device?: CurrentDeviceCommand;
    errors?: ValidationError[] | undefined;
}

export class DeivcePosDetailsDto implements IDeivcePosDetailsDto {
    taxpayerRIN?: string | undefined;
    serialNumber?: string | undefined;
    branchCode?: string | undefined;
    branchStartDate?: Date;
    branchCeaseDate?: Date | undefined;
    taxPayerIsActive?: boolean;
    deviceStatus?: DeviceStatus;
    modelStatus?: ModelStatus;
    vendorStatus?: VendorStatus;
    deviceActiveFrom?: Date;
    deviceActiveTo?: Date | undefined;
    modelActiveFrom?: Date;
    modelActiveTo?: Date | undefined;
    vendorActiveFrom?: Date;
    vendorActiveTo?: Date | undefined;
    firstReceiptDate?: Date | undefined;

    constructor(data?: IDeivcePosDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxpayerRIN = _data["taxpayerRIN"];
            this.serialNumber = _data["serialNumber"];
            this.branchCode = _data["branchCode"];
            this.branchStartDate = _data["branchStartDate"] ? new Date(_data["branchStartDate"].toString()) : <any>undefined;
            this.branchCeaseDate = _data["branchCeaseDate"] ? new Date(_data["branchCeaseDate"].toString()) : <any>undefined;
            this.taxPayerIsActive = _data["taxPayerIsActive"];
            this.deviceStatus = _data["deviceStatus"];
            this.modelStatus = _data["modelStatus"];
            this.vendorStatus = _data["vendorStatus"];
            this.deviceActiveFrom = _data["deviceActiveFrom"] ? new Date(_data["deviceActiveFrom"].toString()) : <any>undefined;
            this.deviceActiveTo = _data["deviceActiveTo"] ? new Date(_data["deviceActiveTo"].toString()) : <any>undefined;
            this.modelActiveFrom = _data["modelActiveFrom"] ? new Date(_data["modelActiveFrom"].toString()) : <any>undefined;
            this.modelActiveTo = _data["modelActiveTo"] ? new Date(_data["modelActiveTo"].toString()) : <any>undefined;
            this.vendorActiveFrom = _data["vendorActiveFrom"] ? new Date(_data["vendorActiveFrom"].toString()) : <any>undefined;
            this.vendorActiveTo = _data["vendorActiveTo"] ? new Date(_data["vendorActiveTo"].toString()) : <any>undefined;
            this.firstReceiptDate = _data["firstReceiptDate"] ? new Date(_data["firstReceiptDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeivcePosDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeivcePosDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxpayerRIN"] = this.taxpayerRIN;
        data["serialNumber"] = this.serialNumber;
        data["branchCode"] = this.branchCode;
        data["branchStartDate"] = this.branchStartDate ? this.branchStartDate.toISOString() : <any>undefined;
        data["branchCeaseDate"] = this.branchCeaseDate ? this.branchCeaseDate.toISOString() : <any>undefined;
        data["taxPayerIsActive"] = this.taxPayerIsActive;
        data["deviceStatus"] = this.deviceStatus;
        data["modelStatus"] = this.modelStatus;
        data["vendorStatus"] = this.vendorStatus;
        data["deviceActiveFrom"] = this.deviceActiveFrom ? this.deviceActiveFrom.toISOString() : <any>undefined;
        data["deviceActiveTo"] = this.deviceActiveTo ? this.deviceActiveTo.toISOString() : <any>undefined;
        data["modelActiveFrom"] = this.modelActiveFrom ? this.modelActiveFrom.toISOString() : <any>undefined;
        data["modelActiveTo"] = this.modelActiveTo ? this.modelActiveTo.toISOString() : <any>undefined;
        data["vendorActiveFrom"] = this.vendorActiveFrom ? this.vendorActiveFrom.toISOString() : <any>undefined;
        data["vendorActiveTo"] = this.vendorActiveTo ? this.vendorActiveTo.toISOString() : <any>undefined;
        data["firstReceiptDate"] = this.firstReceiptDate ? this.firstReceiptDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): DeivcePosDetailsDto {
        const json = this.toJSON();
        let result = new DeivcePosDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IDeivcePosDetailsDto {
    taxpayerRIN?: string | undefined;
    serialNumber?: string | undefined;
    branchCode?: string | undefined;
    branchStartDate?: Date;
    branchCeaseDate?: Date | undefined;
    taxPayerIsActive?: boolean;
    deviceStatus?: DeviceStatus;
    modelStatus?: ModelStatus;
    vendorStatus?: VendorStatus;
    deviceActiveFrom?: Date;
    deviceActiveTo?: Date | undefined;
    modelActiveFrom?: Date;
    modelActiveTo?: Date | undefined;
    vendorActiveFrom?: Date;
    vendorActiveTo?: Date | undefined;
    firstReceiptDate?: Date | undefined;
}

export class DeviceBulkResponseDto implements IDeviceBulkResponseDto {
    acceptedDevices?: AcceptedDeviceDto[] | undefined;
    rejectedDevices?: RejectedDeviceDto[] | undefined;

    constructor(data?: IDeviceBulkResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["acceptedDevices"])) {
                this.acceptedDevices = [] as any;
                for (let item of _data["acceptedDevices"])
                    this.acceptedDevices!.push(AcceptedDeviceDto.fromJS(item));
            }
            if (Array.isArray(_data["rejectedDevices"])) {
                this.rejectedDevices = [] as any;
                for (let item of _data["rejectedDevices"])
                    this.rejectedDevices!.push(RejectedDeviceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceBulkResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceBulkResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.acceptedDevices)) {
            data["acceptedDevices"] = [];
            for (let item of this.acceptedDevices)
                data["acceptedDevices"].push(item.toJSON());
        }
        if (Array.isArray(this.rejectedDevices)) {
            data["rejectedDevices"] = [];
            for (let item of this.rejectedDevices)
                data["rejectedDevices"].push(item.toJSON());
        }
        return data;
    }

    clone(): DeviceBulkResponseDto {
        const json = this.toJSON();
        let result = new DeviceBulkResponseDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceBulkResponseDto {
    acceptedDevices?: AcceptedDeviceDto[] | undefined;
    rejectedDevices?: RejectedDeviceDto[] | undefined;
}

export class DeviceKeyDto implements IDeviceKeyDto {
    modelName?: string | undefined;
    vendorName?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date;

    constructor(data?: IDeviceKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelName = _data["modelName"];
            this.vendorName = _data["vendorName"];
            this.serialNumber = _data["serialNumber"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName;
        data["vendorName"] = this.vendorName;
        data["serialNumber"] = this.serialNumber;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        return data;
    }

    clone(): DeviceKeyDto {
        const json = this.toJSON();
        let result = new DeviceKeyDto();
        result.init(json);
        return result;
    }
}

export interface IDeviceKeyDto {
    modelName?: string | undefined;
    vendorName?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date;
}

export class DeviceKeyModel implements IDeviceKeyModel {
    modelName?: string | undefined;
    vendorName?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date;

    constructor(data?: IDeviceKeyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelName = _data["modelName"];
            this.vendorName = _data["vendorName"];
            this.serialNumber = _data["serialNumber"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceKeyModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceKeyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName;
        data["vendorName"] = this.vendorName;
        data["serialNumber"] = this.serialNumber;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        return data;
    }

    clone(): DeviceKeyModel {
        const json = this.toJSON();
        let result = new DeviceKeyModel();
        result.init(json);
        return result;
    }
}

export interface IDeviceKeyModel {
    modelName?: string | undefined;
    vendorName?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date;
}

export class DeviceModel implements IDeviceModel {
    id?: number;
    modelId?: number;
    modelName?: string | undefined;
    vendorName?: string | undefined;
    taxpayerId?: number;
    taxpayerRIN?: string | undefined;
    branchId?: number;
    branchNumber?: number;
    name?: string | undefined;
    description?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    status?: DeviceStatusDto;
    statusReasonId?: number | undefined;
    statusReason?: string | undefined;
    credentialExpiryDate?: Date | undefined;
    lastReceiptDate?: Date | undefined;

    constructor(data?: IDeviceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modelId = _data["modelId"];
            this.modelName = _data["modelName"];
            this.vendorName = _data["vendorName"];
            this.taxpayerId = _data["taxpayerId"];
            this.taxpayerRIN = _data["taxpayerRIN"];
            this.branchId = _data["branchId"];
            this.branchNumber = _data["branchNumber"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.serialNumber = _data["serialNumber"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusReasonId = _data["statusReasonId"];
            this.statusReason = _data["statusReason"];
            this.credentialExpiryDate = _data["credentialExpiryDate"] ? new Date(_data["credentialExpiryDate"].toString()) : <any>undefined;
            this.lastReceiptDate = _data["lastReceiptDate"] ? new Date(_data["lastReceiptDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modelId"] = this.modelId;
        data["modelName"] = this.modelName;
        data["vendorName"] = this.vendorName;
        data["taxpayerId"] = this.taxpayerId;
        data["taxpayerRIN"] = this.taxpayerRIN;
        data["branchId"] = this.branchId;
        data["branchNumber"] = this.branchNumber;
        data["name"] = this.name;
        data["description"] = this.description;
        data["serialNumber"] = this.serialNumber;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusReasonId"] = this.statusReasonId;
        data["statusReason"] = this.statusReason;
        data["credentialExpiryDate"] = this.credentialExpiryDate ? this.credentialExpiryDate.toISOString() : <any>undefined;
        data["lastReceiptDate"] = this.lastReceiptDate ? this.lastReceiptDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): DeviceModel {
        const json = this.toJSON();
        let result = new DeviceModel();
        result.init(json);
        return result;
    }
}

export interface IDeviceModel {
    id?: number;
    modelId?: number;
    modelName?: string | undefined;
    vendorName?: string | undefined;
    taxpayerId?: number;
    taxpayerRIN?: string | undefined;
    branchId?: number;
    branchNumber?: number;
    name?: string | undefined;
    description?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    status?: DeviceStatusDto;
    statusReasonId?: number | undefined;
    statusReason?: string | undefined;
    credentialExpiryDate?: Date | undefined;
    lastReceiptDate?: Date | undefined;
}

export enum DeviceStatus {
    Pending = "Pending",
    InActive = "InActive",
    Active = "Active",
    Retiring = "Retiring",
    Retired = "Retired",
}

export enum DeviceStatusDto {
    Pending = "Pending",
    InActive = "InActive",
    Active = "Active",
}

export class EditCurrentDeviceDto implements IEditCurrentDeviceDto {
    modelId?: number | undefined;
    branchId?: number;
    name?: string | undefined;
    description?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    status?: DeviceStatusDto;

    constructor(data?: IEditCurrentDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.branchId = _data["branchId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.serialNumber = _data["serialNumber"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EditCurrentDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCurrentDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["branchId"] = this.branchId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["serialNumber"] = this.serialNumber;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }

    clone(): EditCurrentDeviceDto {
        const json = this.toJSON();
        let result = new EditCurrentDeviceDto();
        result.init(json);
        return result;
    }
}

export interface IEditCurrentDeviceDto {
    modelId?: number | undefined;
    branchId?: number;
    name?: string | undefined;
    description?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    status?: DeviceStatusDto;
}

export class GetLookupResponseDto implements IGetLookupResponseDto {
    deviceStatus?: LookupsDto[] | undefined;
    modelStatus?: LookupsDto[] | undefined;
    modelType?: LookupsDto[] | undefined;
    vendorStatus?: LookupsDto[] | undefined;
    countries?: LookupsDto[] | undefined;
    cities?: LookupsDto[] | undefined;
    governorates?: LookupsDto[] | undefined;
    models?: LookupsDto[] | undefined;
    vendors?: LookupsDto[] | undefined;
    taxPayers?: LookupsDto[] | undefined;
    taxPayerBrunches?: LookupsDto[] | undefined;
    vendorDeactivationReasons?: LookupsDto[] | undefined;
    modelDeactivationReasons?: LookupsDto[] | undefined;
    deviceDeactivationReasons?: LookupsDto[] | undefined;
    deviceRetirementReasons?: LookupsDto[] | undefined;
    retiringWindow?: number | undefined;
    header?: ResponseHeader;

    constructor(data?: IGetLookupResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deviceStatus"])) {
                this.deviceStatus = [] as any;
                for (let item of _data["deviceStatus"])
                    this.deviceStatus!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["modelStatus"])) {
                this.modelStatus = [] as any;
                for (let item of _data["modelStatus"])
                    this.modelStatus!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["modelType"])) {
                this.modelType = [] as any;
                for (let item of _data["modelType"])
                    this.modelType!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["vendorStatus"])) {
                this.vendorStatus = [] as any;
                for (let item of _data["vendorStatus"])
                    this.vendorStatus!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["governorates"])) {
                this.governorates = [] as any;
                for (let item of _data["governorates"])
                    this.governorates!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["models"])) {
                this.models = [] as any;
                for (let item of _data["models"])
                    this.models!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["vendors"])) {
                this.vendors = [] as any;
                for (let item of _data["vendors"])
                    this.vendors!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["taxPayers"])) {
                this.taxPayers = [] as any;
                for (let item of _data["taxPayers"])
                    this.taxPayers!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["taxPayerBrunches"])) {
                this.taxPayerBrunches = [] as any;
                for (let item of _data["taxPayerBrunches"])
                    this.taxPayerBrunches!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["vendorDeactivationReasons"])) {
                this.vendorDeactivationReasons = [] as any;
                for (let item of _data["vendorDeactivationReasons"])
                    this.vendorDeactivationReasons!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["modelDeactivationReasons"])) {
                this.modelDeactivationReasons = [] as any;
                for (let item of _data["modelDeactivationReasons"])
                    this.modelDeactivationReasons!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["deviceDeactivationReasons"])) {
                this.deviceDeactivationReasons = [] as any;
                for (let item of _data["deviceDeactivationReasons"])
                    this.deviceDeactivationReasons!.push(LookupsDto.fromJS(item));
            }
            if (Array.isArray(_data["deviceRetirementReasons"])) {
                this.deviceRetirementReasons = [] as any;
                for (let item of _data["deviceRetirementReasons"])
                    this.deviceRetirementReasons!.push(LookupsDto.fromJS(item));
            }
            this.retiringWindow = _data["retiringWindow"];
            this.header = _data["header"] ? ResponseHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLookupResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLookupResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deviceStatus)) {
            data["deviceStatus"] = [];
            for (let item of this.deviceStatus)
                data["deviceStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.modelStatus)) {
            data["modelStatus"] = [];
            for (let item of this.modelStatus)
                data["modelStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.modelType)) {
            data["modelType"] = [];
            for (let item of this.modelType)
                data["modelType"].push(item.toJSON());
        }
        if (Array.isArray(this.vendorStatus)) {
            data["vendorStatus"] = [];
            for (let item of this.vendorStatus)
                data["vendorStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        if (Array.isArray(this.governorates)) {
            data["governorates"] = [];
            for (let item of this.governorates)
                data["governorates"].push(item.toJSON());
        }
        if (Array.isArray(this.models)) {
            data["models"] = [];
            for (let item of this.models)
                data["models"].push(item.toJSON());
        }
        if (Array.isArray(this.vendors)) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item.toJSON());
        }
        if (Array.isArray(this.taxPayers)) {
            data["taxPayers"] = [];
            for (let item of this.taxPayers)
                data["taxPayers"].push(item.toJSON());
        }
        if (Array.isArray(this.taxPayerBrunches)) {
            data["taxPayerBrunches"] = [];
            for (let item of this.taxPayerBrunches)
                data["taxPayerBrunches"].push(item.toJSON());
        }
        if (Array.isArray(this.vendorDeactivationReasons)) {
            data["vendorDeactivationReasons"] = [];
            for (let item of this.vendorDeactivationReasons)
                data["vendorDeactivationReasons"].push(item.toJSON());
        }
        if (Array.isArray(this.modelDeactivationReasons)) {
            data["modelDeactivationReasons"] = [];
            for (let item of this.modelDeactivationReasons)
                data["modelDeactivationReasons"].push(item.toJSON());
        }
        if (Array.isArray(this.deviceDeactivationReasons)) {
            data["deviceDeactivationReasons"] = [];
            for (let item of this.deviceDeactivationReasons)
                data["deviceDeactivationReasons"].push(item.toJSON());
        }
        if (Array.isArray(this.deviceRetirementReasons)) {
            data["deviceRetirementReasons"] = [];
            for (let item of this.deviceRetirementReasons)
                data["deviceRetirementReasons"].push(item.toJSON());
        }
        data["retiringWindow"] = this.retiringWindow;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetLookupResponseDto {
        const json = this.toJSON();
        let result = new GetLookupResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetLookupResponseDto {
    deviceStatus?: LookupsDto[] | undefined;
    modelStatus?: LookupsDto[] | undefined;
    modelType?: LookupsDto[] | undefined;
    vendorStatus?: LookupsDto[] | undefined;
    countries?: LookupsDto[] | undefined;
    cities?: LookupsDto[] | undefined;
    governorates?: LookupsDto[] | undefined;
    models?: LookupsDto[] | undefined;
    vendors?: LookupsDto[] | undefined;
    taxPayers?: LookupsDto[] | undefined;
    taxPayerBrunches?: LookupsDto[] | undefined;
    vendorDeactivationReasons?: LookupsDto[] | undefined;
    modelDeactivationReasons?: LookupsDto[] | undefined;
    deviceDeactivationReasons?: LookupsDto[] | undefined;
    deviceRetirementReasons?: LookupsDto[] | undefined;
    retiringWindow?: number | undefined;
    header?: ResponseHeader;
}

export class InvalidDeviceDto implements IInvalidDeviceDto {
    index?: number;
    device?: DeviceKeyModel;
    errors?: ValidationError[] | undefined;

    constructor(data?: IInvalidDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.device = _data["device"] ? DeviceKeyModel.fromJS(_data["device"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ValidationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvalidDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvalidDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }

    clone(): InvalidDeviceDto {
        const json = this.toJSON();
        let result = new InvalidDeviceDto();
        result.init(json);
        return result;
    }
}

export interface IInvalidDeviceDto {
    index?: number;
    device?: DeviceKeyModel;
    errors?: ValidationError[] | undefined;
}

export class LookupsDto implements ILookupsDto {
    id?: number;
    code?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    parentCode?: string | undefined;

    constructor(data?: ILookupsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.namePrimaryLang = _data["namePrimaryLang"];
            this.nameSecondaryLang = _data["nameSecondaryLang"];
            this.parentCode = _data["parentCode"];
        }
    }

    static fromJS(data: any): LookupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["namePrimaryLang"] = this.namePrimaryLang;
        data["nameSecondaryLang"] = this.nameSecondaryLang;
        data["parentCode"] = this.parentCode;
        return data;
    }

    clone(): LookupsDto {
        const json = this.toJSON();
        let result = new LookupsDto();
        result.init(json);
        return result;
    }
}

export interface ILookupsDto {
    id?: number;
    code?: string | undefined;
    namePrimaryLang?: string | undefined;
    nameSecondaryLang?: string | undefined;
    parentCode?: string | undefined;
}

export class ModelListItemDto implements IModelListItemDto {
    id?: number;
    vendorName?: string | undefined;
    name?: string | undefined;
    certificationNumber?: string | undefined;
    typeName?: string | undefined;
    statusName?: string | undefined;
    status?: ModelStatus;
    description?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    posDeviceCount?: number;
    statusId?: number;
    vendorStatus?: VendorStatus;
    vendorId?: number;
    vendorOutOfRange?: boolean;
    modelOutOfRange?: boolean;
    certified?: boolean | undefined;
    certificationDate?: Date | undefined;

    constructor(data?: IModelListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vendorName = _data["vendorName"];
            this.name = _data["name"];
            this.certificationNumber = _data["certificationNumber"];
            this.typeName = _data["typeName"];
            this.statusName = _data["statusName"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.posDeviceCount = _data["posDeviceCount"];
            this.statusId = _data["statusId"];
            this.vendorStatus = _data["vendorStatus"];
            this.vendorId = _data["vendorId"];
            this.vendorOutOfRange = _data["vendorOutOfRange"];
            this.modelOutOfRange = _data["modelOutOfRange"];
            this.certified = _data["certified"];
            this.certificationDate = _data["certificationDate"] ? new Date(_data["certificationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ModelListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vendorName"] = this.vendorName;
        data["name"] = this.name;
        data["certificationNumber"] = this.certificationNumber;
        data["typeName"] = this.typeName;
        data["statusName"] = this.statusName;
        data["status"] = this.status;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["posDeviceCount"] = this.posDeviceCount;
        data["statusId"] = this.statusId;
        data["vendorStatus"] = this.vendorStatus;
        data["vendorId"] = this.vendorId;
        data["vendorOutOfRange"] = this.vendorOutOfRange;
        data["modelOutOfRange"] = this.modelOutOfRange;
        data["certified"] = this.certified;
        data["certificationDate"] = this.certificationDate ? this.certificationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): ModelListItemDto {
        const json = this.toJSON();
        let result = new ModelListItemDto();
        result.init(json);
        return result;
    }
}

export interface IModelListItemDto {
    id?: number;
    vendorName?: string | undefined;
    name?: string | undefined;
    certificationNumber?: string | undefined;
    typeName?: string | undefined;
    statusName?: string | undefined;
    status?: ModelStatus;
    description?: string | undefined;
    activeFrom?: Date;
    activeTo?: Date | undefined;
    posDeviceCount?: number;
    statusId?: number;
    vendorStatus?: VendorStatus;
    vendorId?: number;
    vendorOutOfRange?: boolean;
    modelOutOfRange?: boolean;
    certified?: boolean | undefined;
    certificationDate?: Date | undefined;
}

export class ModelListItemDtoQueryListResult implements IModelListItemDtoQueryListResult {
    data?: ModelListItemDto[] | undefined;
    totalCount?: number;
    pagesCount?: number;

    constructor(data?: IModelListItemDtoQueryListResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ModelListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pagesCount = _data["pagesCount"];
        }
    }

    static fromJS(data: any): ModelListItemDtoQueryListResult {
        data = typeof data === 'object' ? data : {};
        let result = new ModelListItemDtoQueryListResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pagesCount"] = this.pagesCount;
        return data;
    }

    clone(): ModelListItemDtoQueryListResult {
        const json = this.toJSON();
        let result = new ModelListItemDtoQueryListResult();
        result.init(json);
        return result;
    }
}

export interface IModelListItemDtoQueryListResult {
    data?: ModelListItemDto[] | undefined;
    totalCount?: number;
    pagesCount?: number;
}

export enum ModelSortBy {
    Default = "Default",
    Name = "Name",
    Type = "Type",
    Status = "Status",
    ActiveFrom = "ActiveFrom",
    ActiveTo = "ActiveTo",
    CertificationDate = "CertificationDate",
    PosDeviceCount = "PosDeviceCount",
}

export enum ModelStatus {
    None = "None",
    InActive = "InActive",
    Active = "Active",
}

export enum ModelType {
    HWPOS = "HWPOS",
    SWPOS = "SWPOS",
    SDC = "SDC",
    OnlineService = "OnlineService",
}

export class PosConfigDto implements IPosConfigDto {
    allowTrustedSystemCertification?: boolean;

    constructor(data?: IPosConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowTrustedSystemCertification = _data["allowTrustedSystemCertification"];
        }
    }

    static fromJS(data: any): PosConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowTrustedSystemCertification"] = this.allowTrustedSystemCertification;
        return data;
    }

    clone(): PosConfigDto {
        const json = this.toJSON();
        let result = new PosConfigDto();
        result.init(json);
        return result;
    }
}

export interface IPosConfigDto {
    allowTrustedSystemCertification?: boolean;
}

export class RegenerateDeviceCredentialsDto implements IRegenerateDeviceCredentialsDto {
    revokeDuration?: number | undefined;
    credentialExpiryDate?: Date;

    constructor(data?: IRegenerateDeviceCredentialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revokeDuration = _data["revokeDuration"];
            this.credentialExpiryDate = _data["credentialExpiryDate"] ? new Date(_data["credentialExpiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RegenerateDeviceCredentialsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegenerateDeviceCredentialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revokeDuration"] = this.revokeDuration;
        data["credentialExpiryDate"] = this.credentialExpiryDate ? this.credentialExpiryDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): RegenerateDeviceCredentialsDto {
        const json = this.toJSON();
        let result = new RegenerateDeviceCredentialsDto();
        result.init(json);
        return result;
    }
}

export interface IRegenerateDeviceCredentialsDto {
    revokeDuration?: number | undefined;
    credentialExpiryDate?: Date;
}

export class RegenerateDeviceCredentialsResponseDto implements IRegenerateDeviceCredentialsResponseDto {
    clientID?: string | undefined;
    clientSecretOne?: string | undefined;
    clientSecretTow?: string | undefined;

    constructor(data?: IRegenerateDeviceCredentialsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["clientID"];
            this.clientSecretOne = _data["clientSecretOne"];
            this.clientSecretTow = _data["clientSecretTow"];
        }
    }

    static fromJS(data: any): RegenerateDeviceCredentialsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegenerateDeviceCredentialsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientID"] = this.clientID;
        data["clientSecretOne"] = this.clientSecretOne;
        data["clientSecretTow"] = this.clientSecretTow;
        return data;
    }

    clone(): RegenerateDeviceCredentialsResponseDto {
        const json = this.toJSON();
        let result = new RegenerateDeviceCredentialsResponseDto();
        result.init(json);
        return result;
    }
}

export interface IRegenerateDeviceCredentialsResponseDto {
    clientID?: string | undefined;
    clientSecretOne?: string | undefined;
    clientSecretTow?: string | undefined;
}

export class RejectedDeviceDto implements IRejectedDeviceDto {
    index?: number;
    device?: DeviceModel;
    errors?: ValidationError[] | undefined;

    constructor(data?: IRejectedDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.device = _data["device"] ? DeviceModel.fromJS(_data["device"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ValidationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RejectedDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectedDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }

    clone(): RejectedDeviceDto {
        const json = this.toJSON();
        let result = new RejectedDeviceDto();
        result.init(json);
        return result;
    }
}

export interface IRejectedDeviceDto {
    index?: number;
    device?: DeviceModel;
    errors?: ValidationError[] | undefined;
}

export enum ResponseCode {
    Success = "Success",
    SystemError = "SystemError",
    ValidationError = "ValidationError",
    NotFound = "NotFound",
    InvalidInput = "InvalidInput",
    AuthenticationError = "AuthenticationError",
    AccessLocked = "AccessLocked",
    AccessDenied = "AccessDenied",
}

export class ResponseHeader implements IResponseHeader {
    statusCode?: ResponseCode;
    readonly code?: string | undefined;
    message?: string | undefined;
    target?: string | undefined;
    details?: ValidationError[] | undefined;
    correlationId?: string | undefined;
    requestTime?: Date | undefined;
    readonly responseProcessingTimeInTicks?: number | undefined;

    constructor(data?: IResponseHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            (<any>this).code = _data["code"];
            this.message = _data["message"];
            this.target = _data["target"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ValidationError.fromJS(item));
            }
            this.correlationId = _data["correlationId"];
            this.requestTime = _data["requestTime"] ? new Date(_data["requestTime"].toString()) : <any>undefined;
            (<any>this).responseProcessingTimeInTicks = _data["responseProcessingTimeInTicks"];
        }
    }

    static fromJS(data: any): ResponseHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["code"] = this.code;
        data["message"] = this.message;
        data["target"] = this.target;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["correlationId"] = this.correlationId;
        data["requestTime"] = this.requestTime ? this.requestTime.toISOString() : <any>undefined;
        data["responseProcessingTimeInTicks"] = this.responseProcessingTimeInTicks;
        return data;
    }

    clone(): ResponseHeader {
        const json = this.toJSON();
        let result = new ResponseHeader();
        result.init(json);
        return result;
    }
}

export interface IResponseHeader {
    statusCode?: ResponseCode;
    code?: string | undefined;
    message?: string | undefined;
    target?: string | undefined;
    details?: ValidationError[] | undefined;
    correlationId?: string | undefined;
    requestTime?: Date | undefined;
    responseProcessingTimeInTicks?: number | undefined;
}

export class RetireDeviceError implements IRetireDeviceError {
    index?: number;
    error?: ValidationError;

    constructor(data?: IRetireDeviceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.error = _data["error"] ? ValidationError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RetireDeviceError {
        data = typeof data === 'object' ? data : {};
        let result = new RetireDeviceError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }

    clone(): RetireDeviceError {
        const json = this.toJSON();
        let result = new RetireDeviceError();
        result.init(json);
        return result;
    }
}

export interface IRetireDeviceError {
    index?: number;
    error?: ValidationError;
}

export class RetireDevicesRequestDto implements IRetireDevicesRequestDto {
    devices?: number[] | undefined;
    reasonId?: number | undefined;
    customReason?: string | undefined;

    constructor(data?: IRetireDevicesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(item);
            }
            this.reasonId = _data["reasonId"];
            this.customReason = _data["customReason"];
        }
    }

    static fromJS(data: any): RetireDevicesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetireDevicesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item);
        }
        data["reasonId"] = this.reasonId;
        data["customReason"] = this.customReason;
        return data;
    }

    clone(): RetireDevicesRequestDto {
        const json = this.toJSON();
        let result = new RetireDevicesRequestDto();
        result.init(json);
        return result;
    }
}

export interface IRetireDevicesRequestDto {
    devices?: number[] | undefined;
    reasonId?: number | undefined;
    customReason?: string | undefined;
}

export class RetireDevicesResponseDto implements IRetireDevicesResponseDto {
    errors?: RetireDeviceError[] | undefined;

    constructor(data?: IRetireDevicesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(RetireDeviceError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RetireDevicesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetireDevicesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }

    clone(): RetireDevicesResponseDto {
        const json = this.toJSON();
        let result = new RetireDevicesResponseDto();
        result.init(json);
        return result;
    }
}

export interface IRetireDevicesResponseDto {
    errors?: RetireDeviceError[] | undefined;
}

export class RevertRetireDeviceError implements IRevertRetireDeviceError {
    index?: number;
    error?: ValidationError;

    constructor(data?: IRevertRetireDeviceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.error = _data["error"] ? ValidationError.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RevertRetireDeviceError {
        data = typeof data === 'object' ? data : {};
        let result = new RevertRetireDeviceError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }

    clone(): RevertRetireDeviceError {
        const json = this.toJSON();
        let result = new RevertRetireDeviceError();
        result.init(json);
        return result;
    }
}

export interface IRevertRetireDeviceError {
    index?: number;
    error?: ValidationError;
}

export class RevertRetireDevicesRequestDto implements IRevertRetireDevicesRequestDto {
    devices?: number[] | undefined;

    constructor(data?: IRevertRetireDevicesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(item);
            }
        }
    }

    static fromJS(data: any): RevertRetireDevicesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevertRetireDevicesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item);
        }
        return data;
    }

    clone(): RevertRetireDevicesRequestDto {
        const json = this.toJSON();
        let result = new RevertRetireDevicesRequestDto();
        result.init(json);
        return result;
    }
}

export interface IRevertRetireDevicesRequestDto {
    devices?: number[] | undefined;
}

export class RevertRetireDevicesResponseDto implements IRevertRetireDevicesResponseDto {
    errors?: RevertRetireDeviceError[] | undefined;

    constructor(data?: IRevertRetireDevicesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(RevertRetireDeviceError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RevertRetireDevicesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevertRetireDevicesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }

    clone(): RevertRetireDevicesResponseDto {
        const json = this.toJSON();
        let result = new RevertRetireDevicesResponseDto();
        result.init(json);
        return result;
    }
}

export interface IRevertRetireDevicesResponseDto {
    errors?: RevertRetireDeviceError[] | undefined;
}

export enum SortDir {
    None = "None",
    Asc = "Asc",
    Desc = "Desc",
}

export class TaxpayerDeviceDetailDto implements ITaxpayerDeviceDetailDto {
    id?: number;
    modelId?: number | undefined;
    vendorName?: string | undefined;
    modelName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date | undefined;
    activeTo?: Date | undefined;
    modeTypeName?: string | undefined;
    branchId?: number | undefined;
    branchNumber?: number | undefined;
    branchName?: string | undefined;
    formatedAddress?: string | undefined;
    statusId?: number;
    vendorStatus?: VendorStatus;
    modelStatus?: ModelStatus;
    statusReason?: string | undefined;
    lastStatusReason?: Date | undefined;
    credentialExpiryDate?: Date | undefined;
    lastReceiptDate?: Date | undefined;
    vendorOutOfRange?: boolean;
    modelOutOfRange?: boolean;
    firstAuthenticationDate?: Date | undefined;
    lastAuthenticationDate?: Date | undefined;
    isStatusUpdatedByAdmin?: boolean;
    retiredDate?: Date | undefined;
    permRetiredDate?: Date | undefined;
    lastModifiedByUserId?: string | undefined;
    readonly branchCeaseDate?: Date | undefined;
    readonly branchStartDate?: Date;

    constructor(data?: ITaxpayerDeviceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modelId = _data["modelId"];
            this.vendorName = _data["vendorName"];
            this.modelName = _data["modelName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.serialNumber = _data["serialNumber"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.modeTypeName = _data["modeTypeName"];
            this.branchId = _data["branchId"];
            this.branchNumber = _data["branchNumber"];
            this.branchName = _data["branchName"];
            this.formatedAddress = _data["formatedAddress"];
            this.statusId = _data["statusId"];
            this.vendorStatus = _data["vendorStatus"];
            this.modelStatus = _data["modelStatus"];
            this.statusReason = _data["statusReason"];
            this.lastStatusReason = _data["lastStatusReason"] ? new Date(_data["lastStatusReason"].toString()) : <any>undefined;
            this.credentialExpiryDate = _data["credentialExpiryDate"] ? new Date(_data["credentialExpiryDate"].toString()) : <any>undefined;
            this.lastReceiptDate = _data["lastReceiptDate"] ? new Date(_data["lastReceiptDate"].toString()) : <any>undefined;
            this.vendorOutOfRange = _data["vendorOutOfRange"];
            this.modelOutOfRange = _data["modelOutOfRange"];
            this.firstAuthenticationDate = _data["firstAuthenticationDate"] ? new Date(_data["firstAuthenticationDate"].toString()) : <any>undefined;
            this.lastAuthenticationDate = _data["lastAuthenticationDate"] ? new Date(_data["lastAuthenticationDate"].toString()) : <any>undefined;
            this.isStatusUpdatedByAdmin = _data["isStatusUpdatedByAdmin"];
            this.retiredDate = _data["retiredDate"] ? new Date(_data["retiredDate"].toString()) : <any>undefined;
            this.permRetiredDate = _data["permRetiredDate"] ? new Date(_data["permRetiredDate"].toString()) : <any>undefined;
            this.lastModifiedByUserId = _data["lastModifiedByUserId"];
            (<any>this).branchCeaseDate = _data["branchCeaseDate"] ? new Date(_data["branchCeaseDate"].toString()) : <any>undefined;
            (<any>this).branchStartDate = _data["branchStartDate"] ? new Date(_data["branchStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaxpayerDeviceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerDeviceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modelId"] = this.modelId;
        data["vendorName"] = this.vendorName;
        data["modelName"] = this.modelName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["serialNumber"] = this.serialNumber;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["modeTypeName"] = this.modeTypeName;
        data["branchId"] = this.branchId;
        data["branchNumber"] = this.branchNumber;
        data["branchName"] = this.branchName;
        data["formatedAddress"] = this.formatedAddress;
        data["statusId"] = this.statusId;
        data["vendorStatus"] = this.vendorStatus;
        data["modelStatus"] = this.modelStatus;
        data["statusReason"] = this.statusReason;
        data["lastStatusReason"] = this.lastStatusReason ? this.lastStatusReason.toISOString() : <any>undefined;
        data["credentialExpiryDate"] = this.credentialExpiryDate ? this.credentialExpiryDate.toISOString() : <any>undefined;
        data["lastReceiptDate"] = this.lastReceiptDate ? this.lastReceiptDate.toISOString() : <any>undefined;
        data["vendorOutOfRange"] = this.vendorOutOfRange;
        data["modelOutOfRange"] = this.modelOutOfRange;
        data["firstAuthenticationDate"] = this.firstAuthenticationDate ? this.firstAuthenticationDate.toISOString() : <any>undefined;
        data["lastAuthenticationDate"] = this.lastAuthenticationDate ? this.lastAuthenticationDate.toISOString() : <any>undefined;
        data["isStatusUpdatedByAdmin"] = this.isStatusUpdatedByAdmin;
        data["retiredDate"] = this.retiredDate ? this.retiredDate.toISOString() : <any>undefined;
        data["permRetiredDate"] = this.permRetiredDate ? this.permRetiredDate.toISOString() : <any>undefined;
        data["lastModifiedByUserId"] = this.lastModifiedByUserId;
        data["branchCeaseDate"] = this.branchCeaseDate ? this.branchCeaseDate.toISOString() : <any>undefined;
        data["branchStartDate"] = this.branchStartDate ? this.branchStartDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): TaxpayerDeviceDetailDto {
        const json = this.toJSON();
        let result = new TaxpayerDeviceDetailDto();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerDeviceDetailDto {
    id?: number;
    modelId?: number | undefined;
    vendorName?: string | undefined;
    modelName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    serialNumber?: string | undefined;
    activeFrom?: Date | undefined;
    activeTo?: Date | undefined;
    modeTypeName?: string | undefined;
    branchId?: number | undefined;
    branchNumber?: number | undefined;
    branchName?: string | undefined;
    formatedAddress?: string | undefined;
    statusId?: number;
    vendorStatus?: VendorStatus;
    modelStatus?: ModelStatus;
    statusReason?: string | undefined;
    lastStatusReason?: Date | undefined;
    credentialExpiryDate?: Date | undefined;
    lastReceiptDate?: Date | undefined;
    vendorOutOfRange?: boolean;
    modelOutOfRange?: boolean;
    firstAuthenticationDate?: Date | undefined;
    lastAuthenticationDate?: Date | undefined;
    isStatusUpdatedByAdmin?: boolean;
    retiredDate?: Date | undefined;
    permRetiredDate?: Date | undefined;
    lastModifiedByUserId?: string | undefined;
    branchCeaseDate?: Date | undefined;
    branchStartDate?: Date;
}

export class TaxpayerPosDetailsDto implements ITaxpayerPosDetailsDto {
    taxpayerFirstReceiptDate?: Date | undefined;

    constructor(data?: ITaxpayerPosDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxpayerFirstReceiptDate = _data["taxpayerFirstReceiptDate"] ? new Date(_data["taxpayerFirstReceiptDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaxpayerPosDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxpayerPosDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxpayerFirstReceiptDate"] = this.taxpayerFirstReceiptDate ? this.taxpayerFirstReceiptDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): TaxpayerPosDetailsDto {
        const json = this.toJSON();
        let result = new TaxpayerPosDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ITaxpayerPosDetailsDto {
    taxpayerFirstReceiptDate?: Date | undefined;
}

export class ValidateDeviceResponseDto implements IValidateDeviceResponseDto {
    validDevices?: ValidDeviceDto[] | undefined;
    invalidDevices?: InvalidDeviceDto[] | undefined;

    constructor(data?: IValidateDeviceResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["validDevices"])) {
                this.validDevices = [] as any;
                for (let item of _data["validDevices"])
                    this.validDevices!.push(ValidDeviceDto.fromJS(item));
            }
            if (Array.isArray(_data["invalidDevices"])) {
                this.invalidDevices = [] as any;
                for (let item of _data["invalidDevices"])
                    this.invalidDevices!.push(InvalidDeviceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateDeviceResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateDeviceResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validDevices)) {
            data["validDevices"] = [];
            for (let item of this.validDevices)
                data["validDevices"].push(item.toJSON());
        }
        if (Array.isArray(this.invalidDevices)) {
            data["invalidDevices"] = [];
            for (let item of this.invalidDevices)
                data["invalidDevices"].push(item.toJSON());
        }
        return data;
    }

    clone(): ValidateDeviceResponseDto {
        const json = this.toJSON();
        let result = new ValidateDeviceResponseDto();
        result.init(json);
        return result;
    }
}

export interface IValidateDeviceResponseDto {
    validDevices?: ValidDeviceDto[] | undefined;
    invalidDevices?: InvalidDeviceDto[] | undefined;
}

export class ValidationError implements IValidationError {
    code?: string | undefined;
    target?: string | undefined;
    message?: string | undefined;

    constructor(data?: IValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.target = _data["target"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["target"] = this.target;
        data["message"] = this.message;
        return data;
    }

    clone(): ValidationError {
        const json = this.toJSON();
        let result = new ValidationError();
        result.init(json);
        return result;
    }
}

export interface IValidationError {
    code?: string | undefined;
    target?: string | undefined;
    message?: string | undefined;
}

export class ValidDeviceDto implements IValidDeviceDto {
    index?: number;
    deviceId?: number | undefined;

    constructor(data?: IValidDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.deviceId = _data["deviceId"];
        }
    }

    static fromJS(data: any): ValidDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["deviceId"] = this.deviceId;
        return data;
    }

    clone(): ValidDeviceDto {
        const json = this.toJSON();
        let result = new ValidDeviceDto();
        result.init(json);
        return result;
    }
}

export interface IValidDeviceDto {
    index?: number;
    deviceId?: number | undefined;
}

export enum VendorStatus {
    None = "None",
    InActive = "InActive",
    Active = "Active",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}